import React, { useState, useEffect } from "react";
import axios from "axios";
import { CheckCircle } from "lucide-react";
// Tabs
import DocumentsAdmin from "../DocumentsF/DocumentsAdmin";
import LeaseAgreement from "../Lease AgreementF/LeaseAgreement";
import Invoice from "../invoice/Invoice";
import Billing from "../Billing/Billing";
import Toast from "../StudentDashBoard/Toast";

// Top nav tabs
const tabs = [
  { key: "profile", label: "Profile" },
  { key: "documents", label: "Documents" },
  { key: "lease", label: "Lease Agreement" },
  { key: "invoice", label: "Invoice" },
  { key: "billing", label: "Billing Record" },
];

const ProfileStudentAdm = ({ studentId, showFinalizeButton = true }) => {
  const [activeTab, setActiveTab] = useState("profile");
  const [currentStep, setCurrentStep] = useState(0);
  const [toast, setToast] = useState({ message: "", type: "" });

  const [studentInfo, setStudentInfo] = useState({});
  const [profilePicture, setProfilePicture] = useState(null);

  const [registerUser, setRegisterUser] = useState({
    StudentFirstName: "",
    StudentLastName: "",
    StudentIdNumber: "",
    StudentMiddleName: "",
    StudentPhoneNumber: "",
    Gender: "",
    Email: "",
    StudentNumber: "",
    StudentMedicalCondition: "",
    StudentAddress: "",
  });

  const [university, setUniversity] = useState({
    StudentUniversity: "",
    StudentStudyYear: "",
    StudentCourse: "",
    ResidenceName: "",
    UniversityName: "",
    paymentMethod: " ",
  });

  const [nextOfKin, setNextOfKin] = useState({
    KinFirstName: "",
    KinLastName: "",
    KinRelationShip: "",
    KinPhone: "",
    KinEmail: "",
    KinAddress: "",
    KinIdNumber: "",
  });

  // Fetch all student data when profile tab is active
  useEffect(() => {
    if (!studentId || activeTab !== "profile") return;

    // Personal Info
    axios
      .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/personal/${studentId}`)
      .then((res) => {
        const data = res.data;
        setRegisterUser({
          StudentFirstName: data.firstName || "",
          StudentMiddleName: data.middleName || "",
          StudentLastName: data.lastName || "",
          Gender: data.gender || "",
          StudentIdNumber: data.idNumber || "",
          StudentPhoneNumber: data.phone || "",
          Email: data.email || "",
          StudentNumber: data.studentNumber || "",
          StudentMedicalCondition: data.medicalConditions || "",
          StudentAddress: "",
        });
        setStudentInfo({ StudentFirstName: data.firstName, StudentLastName: data.lastName });
        if (data.profilePictureUrl) setProfilePicture(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/${data.profilePictureUrl}`);
      })
      .catch((err) => console.error("Personal info fetch error:", err));

    // University Info
    axios
      .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/university/${studentId}`)
      .then((res) =>
        setUniversity({
          StudentCourse: res.data.fieldOfStudy || "",
          StudentStudyYear: res.data.yearOfStudy || "",
          paymentMethod: res.data.paymentMethod || " ",
          ResidenceName: res.data.residenceName || "",
          UniversityName: res.data.universityName || "",
        })
      )
      .catch((err) => console.error("University info fetch error:", err));

    // Next of Kin
    axios
      .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/nextofkin/${studentId}`)
      .then((res) =>
        setNextOfKin({
          KinFirstName: res.data.nextOfKinName || "",
          KinLastName: res.data.nextOfKinLastName || "",
          KinRelationShip: res.data.relationship || "",
          KinPhone: res.data.nextOfKinPhone || "",
          KinEmail: res.data.nextOfKinEmail || "",
          KinAddress: res.data.nextOfKinHomeAddress || "",
          KinIdNumber: res.data.nextOfKinIdNumber || "",
        })
      )
      .catch((err) => console.error("Next of Kin fetch error:", err));

    // Address
    axios
      .get(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/address/${studentId}`)
      .then((res) => setRegisterUser((prev) => ({ ...prev, StudentAddress: res.data.streetAddress || "" })))
      .catch((err) => console.error("Address fetch error:", err));
  }, [activeTab, studentId]);

  // Helpers
  const handleChange = (e, setState) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const nextStep = () => setCurrentStep((prev) => Math.min(prev + 1, 2));
  const prevStep = () => setCurrentStep((prev) => Math.max(prev - 1, 0));

  const handleSaveStep = () => {
    // ✅ Use the studentId prop passed into this component instead of localStorage
    const StudentUserId = studentId;
    if (!StudentUserId) return alert("Student ID missing");

 if (currentStep === 0) {
      axios
        .put(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/update/personal/${studentId}`, {
          FirstName: registerUser.StudentFirstName,
          MiddleName: registerUser.StudentMiddleName,
          LastName: registerUser.StudentLastName,
          Gender: registerUser.Gender,
          IdNumber: registerUser.StudentIdNumber,
          Email: registerUser.Email,
          Phone: registerUser.StudentPhoneNumber,
          StudentNumber: registerUser.StudentNumber,
          MedicalConditions: registerUser.StudentMedicalCondition,
          StreetAddress: registerUser.StudentAddress,
        })
        .then((res) => {
          console.log("Update personal response:", res.data);
          setToast({ message: "Personal details saved.", type: "success" });
        })
        .catch((err) => {
          console.error("Update personal error:", err.response?.data || err.message);
          setToast({ message: "Failed to save personal details.", type: "error" });
        });
    }
    else if (currentStep === 1) {
      axios
        .put(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/update/university/${studentId}`, {
          FieldOfStudy: university.StudentCourse,
          YearOfStudy: university.StudentStudyYear,
        })
        .then(() => setToast({ message: "University details saved.", type: "success" }))
        .catch(() => setToast({ message: "Failed to save university details.", type: "error" }));
    } else if (currentStep === 2) {
      axios
        .put(`https://msarestapis-acckcpbyeshpa3f3.southafricanorth-01.azurewebsites.net/api/UserInformation/update/nextofkin/${studentId}`, {
          NextOfKinName: nextOfKin.KinFirstName,
          NextOfKinLastName: nextOfKin.KinLastName,
          Relationship: nextOfKin.KinRelationShip,
          NextOfKinPhone: nextOfKin.KinPhone,
          NextOfKinEmail: nextOfKin.KinEmail,
          NextOfKinIdNumber: nextOfKin.KinIdNumber,
          NextOfKinHomeAddress: nextOfKin.KinAddress,
        })
        .then(() => setToast({ message: "Next of kin details saved.", type: "success" }))
        .catch(() => setToast({ message: "Failed to save next of kin details.", type: "error" }));
    }
  };

  // Render steps
  const renderStep = () => {
    const formClass = "grid grid-cols-1 md:grid-cols-2 gap-5";
const inputClass =
  "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200";
const labelClass = "block text-sm font-medium text-gray-700 mb-1.5";

    if (currentStep === 0) {
      return (
        <div className={formClass}>
          <div>
            <label className={labelClass}>First Name</label>
            <input name="StudentFirstName" value={registerUser.StudentFirstName} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Middle Name</label>
            <input name="StudentMiddleName" value={registerUser.StudentMiddleName} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Last Name</label>
            <input name="StudentLastName" value={registerUser.StudentLastName} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Gender</label>
            <select name="Gender" value={registerUser.Gender} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass}>
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div>
            <label className={labelClass}>ID Number</label>
            <input name="StudentIdNumber" value={registerUser.StudentIdNumber} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Email Address</label>
            <input name="Email" value={registerUser.Email} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Phone Number</label>
            <input name="StudentPhoneNumber" value={registerUser.StudentPhoneNumber} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Student Number</label>
            <input name="StudentNumber" value={registerUser.StudentNumber} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} />
          </div>
          <div className="md:col-span-2">
            <label className={labelClass}>Medical Conditions</label>
            <textarea name="StudentMedicalCondition" value={registerUser.StudentMedicalCondition} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} rows="3" />
          </div>
          <div className="md:col-span-2">
            <label className={labelClass}>Address</label>
            <textarea name="StudentAddress" value={registerUser.StudentAddress} onChange={(e) => handleChange(e, setRegisterUser)} className={inputClass} rows="3" />
          </div>
        </div>
      );
    }

    if (currentStep === 1) {
      return (
        <div className={formClass}>
          <div>
            <label className={labelClass}>University Name</label>
            <input name="UniversityName" value={university.UniversityName} className={`${inputClass} bg-gray-50 cursor-not-allowed`} disabled />
          </div>
          <div>
            <label className={labelClass}>Residence Name</label>
            <input name="ResidenceName" value={university.ResidenceName} className={`${inputClass} bg-gray-50 cursor-not-allowed`} disabled />
          </div>
          <div>
            <label className={labelClass}>Course</label>
            <input name="StudentCourse" value={university.StudentCourse} onChange={(e) => handleChange(e, setUniversity)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Study Year</label>
            <input name="StudentStudyYear" value={university.StudentStudyYear} onChange={(e) => handleChange(e, setUniversity)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Payment Method</label>
            <input name="paymentMethod" value={university.paymentMethod} className={`${inputClass} bg-gray-50 cursor-not-allowed`} disabled />
          </div>
        </div>
      );
    }

    if (currentStep === 2) {
      return (
        <div className={formClass}>
          <div>
            <label className={labelClass}>First Name</label>
            <input name="KinFirstName" value={nextOfKin.KinFirstName} onChange={(e) => handleChange(e, setNextOfKin)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Last Name</label>
            <input name="KinLastName" value={nextOfKin.KinLastName} onChange={(e) => handleChange(e, setNextOfKin)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Relationship</label>
            <input name="KinRelationShip" value={nextOfKin.KinRelationShip} onChange={(e) => handleChange(e, setNextOfKin)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Phone Number</label>
            <input name="KinPhone" value={nextOfKin.KinPhone} onChange={(e) => handleChange(e, setNextOfKin)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Email</label>
            <input name="KinEmail" value={nextOfKin.KinEmail} onChange={(e) => handleChange(e, setNextOfKin)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>ID Number</label>
            <input name="KinIdNumber" value={nextOfKin.KinIdNumber} onChange={(e) => handleChange(e, setNextOfKin)} className={inputClass} />
          </div>
          <div className="md:col-span-2">
            <label className={labelClass}>Address</label>
            <textarea name="KinAddress" value={nextOfKin.KinAddress} onChange={(e) => handleChange(e, setNextOfKin)} className={inputClass} rows="3" />
          </div>
        </div>
      );
    }
  };

  return (
    <div className="space-y-6">
      {/* Top Navigation */}
     <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
  <div className="border-b border-gray-200 bg-gradient-to-r from-slate-50 to-gray-50">
    <nav className="flex space-x-1 px-4">
      {tabs.map(tab => {
        const isActive = activeTab === tab.key;
        return (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`
              px-4 py-2.5 text-sm font-medium transition-all duration-200 relative
              ${isActive
                ? "text-blue-600 border-b-2 border-blue-600 bg-white"
                : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"
              }
            `}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  </div>
</div>
      {/* Main Content */}
      <div className="space-y-6">
       {activeTab === "profile" && (
  <div className="space-y-6">
    {/* Header */}
    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl shadow-lg p-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div className="flex items-center gap-4">
        {profilePicture ? (
          <img
            src={profilePicture}
            alt="Profile"
            className="w-16 h-16 rounded-full object-cover border-2 border-white/30 shadow-md"
          />
        ) : (
          <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center border-2 border-white/30">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#ffffff" viewBox="0 0 24 24">
              <path d="M12 12c2.67 0 8 1.34 8 4v2H4v-2c0-2.66 5.33-4 8-4zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
            </svg>
          </div>
        )}
        <div>
          <h1 className="text-xl font-semibold text-white">
            {studentInfo.StudentFirstName} {studentInfo.StudentLastName}
          </h1>
          <p className="text-sm text-blue-100 mt-0.5">Student Profile Overview</p>
        </div>
      </div>
      <div className="bg-white/15 backdrop-blur-sm rounded-lg px-3 py-1.5 border border-white/20">
        <p className="text-xs text-blue-100">Student ID</p>
        <p className="text-sm font-semibold text-white">{registerUser.StudentNumber || "—"}</p>
      </div>
    </div>

    {/* Stepper + Form */}
    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-5 md:p-6 space-y-6">
      {/* Stepper */}
      <div className="flex items-center gap-3">
        {["Personal", "University", "Next of Kin"].map((step, i) => (
          <div key={i} className="flex items-center flex-1">
            <div className="flex items-center gap-2">
              <div
                className={`
                  w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-200 shadow-sm
                  ${currentStep === i
                    ? "bg-gradient-to-br from-blue-600 to-indigo-600 text-white"
                    : currentStep > i
                      ? "bg-gradient-to-br from-emerald-500 to-emerald-600 text-white"
                      : "bg-gray-100 text-gray-400 border border-gray-200"
                  }
                `}
              >
                {currentStep > i ? "✓" : i + 1}
              </div>
              <span className={`text-sm font-medium hidden sm:inline ${currentStep === i ? "text-gray-900" : currentStep > i ? "text-emerald-600" : "text-gray-400"}`}>
                {step}
              </span>
            </div>
            {i < 2 && (
              <div className={`flex-1 h-0.5 mx-3 rounded transition-colors duration-200 ${currentStep > i ? "bg-emerald-400" : "bg-gray-200"}`} />
            )}
          </div>
        ))}
      </div>

      {/* Form */}
      {renderStep()}

      {/* Buttons */}
      <div className="flex flex-col sm:flex-row justify-between gap-3 pt-4 border-t border-gray-100">
        {currentStep > 0 && (
          <button
            onClick={prevStep}
            className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 transition-all duration-200"
          >
            Previous
          </button>
        )}
        <div className="flex gap-3 ml-auto">
          <button
            onClick={handleSaveStep}
            className="px-4 py-2 text-sm font-medium rounded-lg bg-emerald-500 text-white hover:bg-emerald-600 transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2"
          >
            <CheckCircle className="w-4 h-4" />
            Save Changes
          </button>
          {currentStep < 2 && (
            <button
              onClick={nextStep}
              className="px-4 py-2 text-sm font-medium rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              Next Step
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
)}

        {/* Other Tabs */}
        {activeTab === "documents" && <DocumentsAdmin studentId={studentId} />}
        {activeTab === "lease" && <LeaseAgreement studentId={studentId} showFinalizeButton={showFinalizeButton} />}
        {activeTab === "invoice" && <Invoice studentId={studentId} />}
        {activeTab === "billing" && <Billing studentId={studentId} />}
      </div>

      {/* Toast */}
      {toast.message && <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: "", type: "" })} />}
    </div>
  );
};

export default ProfileStudentAdm;